import React, { createContext, useContext, useMemo } from "react";
import { getLocalizationsFor } from "../../localization";
const TheLocalizationContext = createContext(undefined);
export const ProductOptionsTranslations = (props) => {
    const localization = useMemo(() => getLocalizationsFor(props.locale), [props.locale]);
    return (React.createElement(TheLocalizationContext.Provider, { value: localization }, localization && props.children));
};
export const useProductOptionsTranslations = () => {
    const ctx = useContext(TheLocalizationContext);
    if (ctx === undefined) {
        throw new Error("useProductOptionsTranslations must be used with localization provider");
    }
    return {
        i18n: (key) => ctx[key],
        i18nUnsafe: (key) => ctx[key],
    };
};
//# sourceMappingURL=product-option-translations.js.map